export default (that) => [
  {
    text: that.$l('btn_label_inspection_apply_view') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_label_inspection_apply_edit') || '编辑单据',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ applyStatus }) => !['1'].includes(`${applyStatus || ''}`),
  },
  {
    text: that.$l('btn_label_inspection_apply_delete') || '删除单据',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    disabled: ({ applyStatus }) => !['1'].includes(`${applyStatus || ''}`),
  },
  {
    text: that.$l('btn_label_inspection_apply_submit') || '需求提交',
    icon: 'el-icon-check',
    menuType: 'submit',
    divided: true,
    allow: 'S',
    disabled: ({ applyStatus }) => !['1'].includes(`${applyStatus || ''}`),
  },
]

